import { jsx as _jsx } from "react/jsx-runtime";
const SvgMessage = (props) => {
    if (process.env.NODE_ENV !== "production") {
        if (props["aria-hidden"] !== "true" &&
            props["aria-label"] === undefined) {
            console.warn('aria-hidden="true" or aria-label should be passed to svg icon for better user experience. Use aria-label="" if you have reason to do so.');
        }
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", "data-svgtype": "icon-default", ...props, children: _jsx("path", { d: "M447.1 0h-384C27.85 0-.9 28.75-.9 63.1v287.1c0 35.25 28.75 63.1 64 63.1h96v83.98c0 9.837 11.02 15.55 19.12 9.7l124.9-93.68h144c35.25 0 64-28.75 64-63.1V63.1C511.1 28.75 483.2 0 447.1 0zM480 352c0 17.6-14.4 32-32 32H303.9a32.004 32.004 0 0 0-19.21 6.406L192 460v-60c0-8.838-7.164-16-16-16H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288z" }) }));
};
export default SvgMessage;
